import { User } from 'types/auth'
import { UserStatusEnum } from 'types/subscription'

export const isPremiumOrPremiumCancelling = (user: User) => {
	return (
		user &&
		[UserStatusEnum.PREMIUM, UserStatusEnum.PREMIUM_CANCELLING].includes(
			user.status,
		)
	)
}
